var viewer_default = {
  "gallery_container": "-sepG",
  "imageTitleContainer": "_3UEgM",
  "clickableItem": "AVPLv",
  "prerender": "aF6Y2",
  "expandButton": "FGuqe",
  "itemContainer": "zl-sM",
  "expandIcon": "sSHS2",
  "itemOverlay": "PEjlQ",
  "imageTitle": "Nnbx-",
  "pointer": "yK5CQ",
  "fadeIn": "REXLD",
  "changing_background": "YBuBg"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
